module.exports = __webpack_public_path__ + "static/media/soundcloud.c65d4007.jpg";